// Provides a memoized ApiClient that resolves a fresh Cognito id token per request.
//
// The client calls freshIdToken() on each request, which refreshes the short-lived id
// token from the long-lived refresh token when it has expired, so a session does not 401
// after an hour. When the session cannot be refreshed at all, onAuthFailure signs the
// user out, which drops the app back to the login screen.

import { useMemo } from "react";

import { freshIdToken } from "../auth/cognito";
import { useAuth } from "../auth/useAuth";
import { ApiClient, apiBaseUrl } from "./client";

export function useApi(): ApiClient {
  const { signOut } = useAuth();
  return useMemo(
    () => new ApiClient(apiBaseUrl(), () => freshIdToken(), signOut),
    [signOut],
  );
}
